import { createContext, type Dispatch, type SetStateAction } from "react";

import type { TrackConfiguration, TrackFeatures } from "../../types.ts";

export interface TrackConfigurationContextType {
  trackConfiguration: TrackConfiguration;
  setTrackConfiguration: (trackConfiguration: TrackConfiguration) => void;
  applyChanges: (values: TrackConfiguration) => void;
  selectedGroupIds: string[];
  setSelectedGroupIds: Dispatch<SetStateAction<string[]>>;
  setGroupsToDelete: Dispatch<SetStateAction<string[]>>;
  groupsToDelete: string[];
  availableTrackConfiguration: Map<string, TrackFeatures>;
  isLoading: boolean;
}

const initialTrackConfigurationContextValue: TrackConfigurationContextType = {
  trackConfiguration: new Map<string, TrackFeatures>(),
  setTrackConfiguration: () => undefined,
  applyChanges: () => {},
  selectedGroupIds: [],
  setSelectedGroupIds: () => {},
  groupsToDelete: [],
  setGroupsToDelete: () => {},
  availableTrackConfiguration: new Map<string, TrackFeatures>(),
  isLoading: false,
};

export const TrackConfigurationContext = createContext<TrackConfigurationContextType>(
  initialTrackConfigurationContextValue,
);
